/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable global-require */
import React from 'react';
import Loading from 'components/Error/Loading';
import CustomContainer from 'components/Containers/Container';
import CustomCard from 'components/Containers/Card';
import { ListGroupItem, CardBody, ListGroup, Container, Row, Col, Card } from 'reactstrap';
import slides from './slides';

const StudyWithTeacher = () => {
  const [state, setState] = React.useState({
    loading: false,
    imgIndex: 0,
    listVideo: slides,
  });

  const changeImg = (index) => {
    setState(pre => ({ ...pre, imgIndex: index }));
  };

  const renderListVideo = () => {
    const { listVideo, imgIndex } = state;
    const list = listVideo.map((item, index) => {
      const color = ['warning', 'success', 'danger', 'info', 'default'];
      const randomIndex = Math.floor(Math.random(color) * 5);
      const name = `checklist-item checklist-item-${color[randomIndex]}`;
      const className = imgIndex === index ? 'checklist-entry flex-column align-items-start py-4 px-4 active text-white' : 'checklist-entry flex-column align-items-start py-4 px-4';
      const classNameText = imgIndex === index ? 'checklist-title mb-0 text-white' : 'checklist-title mb-0';
      return (
        <ListGroupItem key={item.id} onClick={() => changeImg(index)} className={className}>
          <div className={name}>
            <div className='checklist-info'>
              <h5 className={classNameText}>{item.name}</h5>
              <small>{item.fileType}</small>
            </div>
            <div>
              <div className='custom-control custom-checkbox custom-checkbox-warning'>
                <i className='fas fa-play-circle' style={{ cursor: 'pointer', fontSize: 20 }} onClick={() => { window.open(item.url); changeImg(index); }} />
              </div>
            </div>
          </div>
        </ListGroupItem>
      );
    });
    return list;
  };

  const { listVideo, loading, imgIndex } = state;
  const imgUrl = listVideo[imgIndex]?.img;
  if (loading) {
    return <Loading />;
  }

  return (
    <CustomContainer name='Học cùng giáo viên bản ngữ' parentName='LMS'>
      <CustomCard bodyStyles={{ padding: 0 }} title='Nội dung bài giảng'>
        <Container className='mt-2' fluid>
          <Row>
            <Col xs={12} sm={12} md={12} xl={6} lg={6}>
              <img className='my-2' src={imgUrl} alt="img" />
            </Col>
            <Col xs={12} sm={12} md={12} xl={6} lg={6}>
              <Card>
                <CardBody className='p-0'>
                  <ListGroup data-toggle='checklist' flush>
                    {renderListVideo()}
                  </ListGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </CustomCard>
    </CustomContainer>
  );
};

export default StudyWithTeacher;
